module.exports = __webpack_public_path__ + "img/phone_auth.45087c55.svg";